module.exports = __webpack_public_path__ + "img/vision.7babc4e8.jpg";